import { gql } from '@apollo/client';

/**
 * 揽收站点 2.0 灰度开关（后端单一源，pickup common_config `express2_gray_switch`）。
 * 前后端读同一份名单——前端不再各自维护 localStorage。
 */
export const GET_EXPRESS2_GRAY_SWITCH = gql`
  query GetExpress2GraySwitch {
    getExpress2GraySwitch {
      wholeSwitch
      hubIds
    }
  }
`;

export interface Express2GraySwitchType {
  wholeSwitch: boolean;
  hubIds: number[];
}

export interface GetExpress2GraySwitchResponse {
  getExpress2GraySwitch: Express2GraySwitchType;
}
